export default "__VITE_ASSET__Bo039pNA__"